import React, { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import ClientImg from "../../assets/images/equipo.png";
import Swipe from "../common/GalleryComponent/Swipe";
// import Slider from "react-slick";
import SwipeableViews from "react-swipeable-views";

function Clients() {
  const mobMatch = useMediaQuery("(max-width:600px)");
  const ClientCard = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: {
            xs: "180px",
            sm: "172px",
          },
          height: {
            xs: "130px",
            sm: "130px",
          },
          boxShadow:
            "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          borderRadius: "8px",
        }}
      >
        <img width="80px" height="80px" src={ClientImg} alt="client" />,
      </Box>
    );
  };
  const arr = [
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
    <ClientCard />,
  ];
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = arr.length;
  const handleNext = () => {
    setActiveStep((prevActiveStep) =>
      activeStep === maxSteps - 1 || activeStep > maxSteps
        ? prevActiveStep
        : prevActiveStep + 1
    );
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) =>
      activeStep === 0 ? prevActiveStep : prevActiveStep - 1
    );
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  return (
    <Container
      sx={{
        marginY: { xs: "0px", sm: "72px" },
        background: "#fff",
        borderRadius: { xs: "8px", sm: "0px" },
        padding: { xs: "24px 16px", sm: "0px" },
      }}
      disableGutters={true}
    >
      <Box>
        <Typography
          variant={mobMatch ? "h3" : "h2"}
          sx={{
            fontSize: { xs: "22px", sm: "32px" },
            lineHeight: { xs: "26px", sm: "36px" },
            fontWeight: { xs: "600", sm: "700" },
            color: "text.primary",
            marginBottom: "8px",
            width: "383px",
          }}
        >
          Our Clients
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant={mobMatch ? "caption" : "body1"}
            sx={{
              fontSize: { xs: "12px", sm: "16px" },
              lineHeight: { xs: "16px", sm: "24px" },
              fontWeight: "400",
              color: "#616161",
              width: "600px",
            }}
          >
            We aim to build a smooth and straightforward relationship between
            our users, providing a streamlined solution that suits their needs.
          </Typography>
          {!mobMatch && (
            <Box>
              <Swipe
                arrowColor="#1f1f1f"
                onClick={handleBack}
                swipeStyle={{ marginRight: "24px" }}
                sx={{
                  display: activeStep === 0 && "none",
                }}
              />
              <Swipe
                sx={{
                  display:
                    activeStep === maxSteps - 1 || activeStep > maxSteps
                      ? "none"
                      : "block",
                }}
                direction="right"
                onClick={handleNext}
                arrowColor="#1f1f1f"
              />
            </Box>
          )}
        </Box>
      </Box>

      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          marginTop: "56px",
          "& .react-swipeable-view-container ": {
            columnGap: { sm: "24px" },
            alignItems: "center",
            transform:
              !mobMatch &&
              `translate(${
                activeStep === 0 ? "0px" : `-${activeStep * 204}px`
              } ,0px) !important`,
            "& > div": {
              width: { sm: "max-content !important" },
              height: "fit-content !important",
            },
          },
        }}
        disableGutters={true}
      >
        <SwipeableViews
          axis={"x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {arr.map((step, index) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4px ",
              }}
              key={index}
            >
              {step}
            </div>
          ))}
        </SwipeableViews>
      </Container>
    </Container>
  );
}

export default Clients;
